import { createReducer, on } from '@ngrx/store';
import { initialServiceCenterState, ServiceCenterState } from './service-center.state';
import { SC_ACTIONS } from '.';

export const serviceCenterReducer = createReducer(
  initialServiceCenterState,

  // Service Centers
  on(
    SC_ACTIONS.triggerServiceCenters,
    (state): ServiceCenterState => ({
      ...state,
      loading: true,
    })
  ),
  on(
    SC_ACTIONS.serviceCentersSuccess,
    (state, { serviceCenters }): ServiceCenterState => ({
      ...state,
      serviceCenters,
      loading: false,
    })
  ),
  on(
    SC_ACTIONS.serviceCentersFailure,
    (state, { error }): ServiceCenterState => ({ ...state, error, loading: false })
  )
);
